import React from 'react';
import PropTypes from 'prop-types';
import { useSchool } from '../../SchoolContext';
import { getDescriptionData } from '../../utils';
import ProfileSection from '../ProfileSection';

function Description({ isFetching }) {
  const { schoolData } = useSchool();
  const descriptionData = getDescriptionData(schoolData || {});

  if (isFetching) {
    return <>...loading</>;
  }

  return (
    <ProfileSection title="Descripción">
      <div>
        {descriptionData}
      </div>
    </ProfileSection>
  );
}

Description.propTypes = {
  isFetching: PropTypes.bool.isRequired,
};

export default Description;
